import React, { useState } from 'react';
import { IconButton } from '../../../../components/IconButton';
import { CreateAPIKeyModal } from '../APIKeyModal/CreateAPIKeyModal';

interface PropTypes {
  disabled?: boolean;
}
export default function GenerateButton({ disabled }: PropTypes) {
  const [createAPIKeyModalOpen, setCreateAPIKeyModalOpen] = useState(false);
  const [newAPIKeyCreated, setNewAPIKeyCreated] = useState(false);
  const onClose = () => {
    setCreateAPIKeyModalOpen(false);
    if (newAPIKeyCreated) window.location.reload();
  };
  const onNewAPIKeyCreated = () => {
    setNewAPIKeyCreated(true);
  };
  return (
    <>
      <IconButton
        color='primary'
        iconName={'bi-plus-circle'}
        size={'md'}
        buttonClass='ms-3'
        buttonText='Generate API Key'
        onClick={() => {
          setCreateAPIKeyModalOpen(true);
        }}
        disabled={disabled}
      />

      {createAPIKeyModalOpen && (
        <CreateAPIKeyModal onSubmit={onNewAPIKeyCreated} onClose={onClose} />
      )}
    </>
  );
}
